import React, { useState } from "react";
import SearchIcon from "../../assets/icons/Search.svg";
import Arrowup from "../../assets/icons/arrow-down.png";

const FilterDropdown = () => {
  const [selectedProperty1, setSelectedProperty1] = useState("Filter by Units");
  const [selectedProperty2, setSelectedProperty2] = useState("Filter by Date Range");
  const [selectedDate, setSelectedDate] = useState("Filter by Date Range");

  const [showDropdown1, setShowDropdown1] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);
  const [showDateDropdown, setShowDateDropdown] = useState(false);

  const showSecondPropertyDropdown = false; // False to see the other options

  const unitsOptions = ["All properties", "Individual properties"];
  const dateOptions1 = ["Custom", "This week", "This month"];
  const dateOptions2 = ["Last 3 months", "Last 6 months", "Last 12 months"];

  const toggleDropdowns = (type) => {
    setShowDropdown1(type === "property1" ? !showDropdown1 : false);
    setShowDropdown2(type === "property2" ? !showDropdown2 : false);
    setShowDateDropdown(type === "date" ? !showDateDropdown : false);
  };

  return (
    <div
      className={`
        bg-white max-w-[1080px] w-full mx-auto
        p-[1.875rem] rounded-lg shadow-md
        flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3
        ${showSecondPropertyDropdown ? "" : "sm:h-[105px]"}
      `}
    >
      {showSecondPropertyDropdown ? (
        <div className="flex flex-col sm:flex-row sm:flex-nowrap sm:items-center gap-4 w-full">
          {/* Search bar */}
          <div className="flex items-center border border-[#ccc] rounded-md px-3 w-full sm:w-[266px] h-[45px] min-w-0">
            <img src={SearchIcon} alt="Search" className="w-4 h-4 mr-2" />
            <input
              type="text"
              placeholder="Tenant name / Unit ID"
              className="w-full focus:outline-none text-sm text-[#1c1c1c] bg-white min-w-0"
            />
          </div>

          {/* Dropdowns */}
          <Dropdown
            label={selectedProperty1}
            options={unitsOptions}
            show={showDropdown1}
            onToggle={() => toggleDropdowns("property1")}
            onSelect={(val) => {
              setSelectedProperty1(val);
              setShowDropdown1(false);
            }}
            sizeClass="w-full sm:w-[266px] h-[45px] min-w-0"
          />
          <Dropdown
            label={selectedProperty2}
            options={dateOptions1}
            show={showDropdown2}
            onToggle={() => toggleDropdowns("property2")}
            onSelect={(val) => {
              setSelectedProperty2(val);
              setShowDropdown2(false);
            }}
            sizeClass="w-full sm:w-[266px] h-[45px] min-w-0"
          />

          {/* Buttons */}
          <div className="flex gap-2 w-full sm:w-auto sm:ml-auto">
            <button className="bg-[#A566FF] text-white text-xs rounded-md px-4 h-[45px] w-[83px] min-w-0">
              SEARCH
            </button>
            <button className="bg-[#873FE2] text-white text-xs rounded-md px-4 h-[45px] w-[90px] min-w-0 mx-auto flex items-center justify-center">
              DOWNLOAD
            </button>
          </div>
        </div>
      ) : (
        <>
          {/* Default layout */}
          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <Dropdown
              label={selectedProperty1 === "Filter by Units" ? "Filter by Property" : selectedProperty1}
              options={unitsOptions}
              show={showDropdown1}
              onToggle={() => toggleDropdowns("property1")}
              onSelect={(val) => {
                setSelectedProperty1(val);
                setShowDropdown1(false);
              }}
              sizeClass="w-full sm:w-[50%] h-[45px]"
            />
            <Dropdown
              label={selectedDate}
              options={dateOptions2}
              show={showDateDropdown}
              onToggle={() => toggleDropdowns("date")}
              onSelect={(val) => {
                setSelectedDate(val);
                setShowDateDropdown(false);
              }}
              sizeClass="w-full sm:w-[50%] h-[45px]"
            />
          </div>

          {/* Only search button */}
          <div className="flex flex-wrap sm:flex-row gap-2 w-full sm:w-auto justify-end">
            <button className="bg-[#A566FF] text-white text-xs rounded-md px-4 h-[45px] w-[83px]">
              SEARCH
            </button>
          </div>
        </>
      )}
    </div>
  );
};

const Dropdown = ({ label, options, show, onToggle, onSelect, sizeClass }) => {
  return (
    <div className={`relative min-w-0 ${sizeClass}`}>
      <button
        onClick={onToggle}
        className={`
          w-full h-full
          border border-[#81818180]
          text-left px-4
          text-[#9D9D9D]
          flex items-center justify-between
          ${show ? "rounded-t-md" : "rounded-md"}
        `}
      >
        <span className="truncate flex-1">{label}</span>
        <img
          src={Arrowup}
          alt="Arrow Icon"
          className={`max-w-[30px] max-h-[22px] transition-transform duration-300 ${show ? "rotate-180" : ""}`}
        />

      </button>

      {show && (
        <div className="absolute z-10 w-full bg-white border border-[#81818180] text-[#9D9D9D] border-t-0 rounded-b-md shadow-lg">
          {options.map((option, i) => (
            <div
              key={option}
              className={`px-4 py-2.5 cursor-pointer hover:bg-gray-200 ${
                i === options.length - 1 ? "rounded-b-md" : ""
              }`}
              onClick={() => onSelect(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;